import { useEffect, useState } from 'react';
import { FlexGrid, Typography, useThemeProvider, Card, Skeleton, useDialog, Link } from '@albo-ui/core'
import { Box, IconButton, Tab, Tabs, TextField, Divider, Tooltip } from '@mui/material';
import { CheckCircleOutline, KeyboardArrowUp, KeyboardArrowDown, Add, Alarm, Delete, Edit } from '@mui/icons-material';
import { crmTabs } from '../../../util/DataObject';
import CustomPagination from '../../elements/CustomPagination';
import TextEditor from '../../elements/DraftEditor/TextEditor';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { ManageEvent } from '../../modals/leads-crm/ManageEvent';
import { ManageTask } from '../../modals/leads-crm/ManageTask';
import { useCRMTask } from './hooks/useCRMTask';
import { CRMLeadProps } from './types';
import MUIRichTextEditor from 'mui-rte';
import emptyTask from "../../../images/emptyTask.png";
import emptyCalendar from "../../../images/emptyCalendar.png";
import DeleteEvent from '../../modals/leads-crm/DeleteEvent';
import "./../../elements/DraftEditor/DraftEditor.css"
import moment from 'moment';
moment.locale('es');

export const CRMTasks = ({ changeAlert, changeLoader, sectionData: lead, item, pplTab }: CRMLeadProps) => {
    const editorTheme = createTheme();
    const dialogProps = useDialog();
    const dialogEvent = useDialog();
    const dialogEventDelete = useDialog();
    const { theme } = useThemeProvider();
    const [ openTask, setOpenTask ] = useState('');
    const [ itemDialog, setItemDialog ] = useState(null);
    const [ element, setElement ] = useState('');

    Object.assign(editorTheme, {
        overrides: {
            MUIRichTextEditor: {
                root: {
                    '& div': {
                        fontSize: "inherit !important",
                    },
                    '& h1, h2': {
                        padding: "0px !important",
                        margin: "0px !important"
                    },
                },
                editor: {
                    lineHeight: 2,
                    '& li': {
                        marginLeft: 16,
                    }
                }
            },
        },
    });

    const { data, filterTasks, tabActive, loading: loadingData, tabs, showEditor, screenType, pagination, getTasks, createTasks, changeTab, changePage, handleChangeRowsPerPage, onOpenTextEditor, addComment, onCloseTextEditor, onUpdateTask, onDeleteTask } = useCRMTask(changeAlert, pplTab);
    
    useEffect(() => {
        if(item && item['open']){
            setItemDialog(item);
            dialogProps.openDialog();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [item]);
    useEffect(() => {
        setItemDialog(null);
        if (lead && lead["uuid"]) {
            getTasks(lead);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lead]);
    useEffect(() => {
        changeLoader(loadingData)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadingData]);

    const onShowInfoTask  = (uuid) => {
		uuid === openTask ? setOpenTask('') : setOpenTask(uuid)
	};
    const getMessage = () => {
        var test = crmTabs.filter((t) => t[pplTab])
        switch (test[0]["image"]) {
            case "emptyTask":
                test[0]["image"] = emptyTask;
                break;
            case "emptyCalendar":
                test[0]["image"] = emptyCalendar;
                break;
        }
        return test
    };
    const getText = (text) => {
        const content = JSON.parse(text);
        return content['blocks'][0]['text']
    };
    const getCount = (text) => {
        const content = JSON.parse(text);
        let count = 0;
        let textCount = 0;

        content['blocks'].map((item) => count += item.text.length);
        content['blocks'].map((item) => textCount++);

        return textCount > 1 ? 100 : count
    };
    const onCloseDialogAction = () => {
        setItemDialog(null);
        dialogProps.onClose();        
        dialogEvent.onClose();
        dialogEventDelete.onClose();
    };
    const onConfirmAction = (req) => {
        dialogProps.onClose();        
        dialogEvent.onClose();

        itemDialog["edit"] ? onUpdateTask(req, "update") : createTasks(req["data"] ? req : {data: req});
        setItemDialog(null);
    };

    const onConfirmDelete = () => {
        dialogEventDelete.onClose();
        onDeleteTask(itemDialog);
        setItemDialog(null);
    };

    const onOpenDialogAction = (test) => {
        let i = {
            app_uuid: lead["app_uuid"],
            uuid: data['uuid'],
            open: true,
            tooltip: "Nueva tarea",
            sectionName: pplTab
        };

        if(test && pplTab === "meet"){
            i["lead_uuid"] = test['lead_uuid']
            i["tooltip"] = "Editar evento"
            i["uuid"] = test["uuid"]
            i["edate"] = test["edate"]
            i["description"] = test["description"]
            i["edit"] = true
            dialogEvent.openDialog();
        } else if(pplTab === "meet"){
            i["uuid"] = lead['uuid']
            i["tooltip"] = "Agregar evento"
            dialogEvent.openDialog();
        } else if(test && pplTab === "task"){
            i["lead_uuid"] = test['lead_uuid']
            i["tooltip"] = "Editar tarea"
            i["uuid"] = test["uuid"]
            i["edate"] = test["edate"]
            i["description"] = test["description"]
            i["edit"] = true
            dialogProps.openDialog();
        } else {
            i["uuid"] = lead['uuid']
            i["tooltip"] = "Nueva tarea"
            dialogProps.openDialog();
        }
        setItemDialog(i);
    };
    const onDelete = (uuid, action) => {
        dialogEventDelete.openDialog();
        setElement(action);
        setItemDialog(uuid)
    }
    
    return (
        <FlexGrid container fullWidth style={{display: 'block', marginTop: 16}} >
            <Card padding={3} flexDirection='column' fullWidth fullHeight alignItems='stretch' style={{ borderColor: theme.colors.manatee, margin: "3px 3px 10px", minHeight: "450px" }}> 
                { loadingData ?
                    <Skeleton width='100%' height='100px' />
                    :    
                    <>
                    <FlexGrid container fullWidth justify='space-between'>
                        {screenType.map((s,i) => {
                            return s["key"] === pplTab && <Typography key={i} variant='h2' style={{display: 'flex', alignItems: 'center', fontSize: '1.2rem'}}>
                                {s["icon"]} {s["title"]}
                            </Typography>
                        })}
                        <Box display={'flex'}>
                            <Link onClick={onOpenDialogAction.bind(this, null)} bold underlined style={{ display: 'flex',  alignItems: 'center', justifyContent: "end", marginRight: 20 }} typography='smallTitle'>
                                <Add style={{ marginRight: 4, marginLeft: -8 }} /> Agregar {pplTab === "meet" ? "evento" : "tarea"}
                            </Link>
                        </Box>
                    </FlexGrid>

                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }} my={1} >
                        <Tabs value={tabActive} indicatorColor='secondary' textColor='secondary' variant='fullWidth'>
                            {tabs.map((item, index) => {
                                return item["type"] === pplTab && <Tab key={index} label={item.title} value={item.key} onClick={changeTab.bind(this, item.key)} sx={{textTransform: 'none', fontWeight: 700, fontFamily: 'Muli,sans-serif', fontSize: 14}} />
                            })}
                        </Tabs>
                    </Box>
                    { pplTab === "meet" && filterTasks?.map((task, i) => {
                        return <Box key={i} display={'contents'} justifyContent={'space-between'} mb={2}>
                            <Typography variant='smallTitle' style={{mr: 5}} >{task['description']}</Typography>
                            <Box display={'flex'} justifyContent={'space-between'}>
                                <Typography variant='paragraph' style={{display: 'flex', alignItems: 'center', marginBottom: 10}}>
                                    { !task['is_completed'] ? 
                                        <Tooltip title={'Pendiente: Cerrar evento'}>
                                            <IconButton sx={{px: '0 !important', mr: 1}} onClick={onUpdateTask.bind(this, task['uuid'], 'completed')} ><Alarm fontSize='small' color='warning' cursor={'pointer'}/></IconButton>
                                        </Tooltip> :
                                        task['is_completed'] ? 
                                        <Tooltip title={'Completado'}>
                                            <IconButton sx={{px: '0 !important', mr: 1}} ><Alarm fontSize='small' color='success'/></IconButton>
                                        </Tooltip> :
                                        null
                                    } 
                                    <Typography variant='paragraph' style={{textTransform: "capitalize"}}>{moment(new Date(task['edate'])).format('dddd')}</Typography>, {moment(new Date(task['edate'])).format('LLL')}
                                </Typography>
                                {tabActive !== "history" && <Box color={"#3743aa"}>
                                    <Edit sx={{mr: 1}} onClick={onOpenDialogAction.bind(this, task)} cursor={'pointer'}/>
                                    <Delete onClick={onDelete.bind(this, task['uuid'], "delete")} cursor={'pointer'}/>
                                </Box>}
                            </Box>
                        </Box>
                    })}

                    { pplTab === "task" && filterTasks?.map((task, i) => {
                        var t = crmTabs.filter((t) => t[task['type']])[0]
                        return <Card key={`${i}-${task['uuid']}`} padding={2} fullWidth flexDirection='column' alignItems='stretch' justifyContent='space-between'
                            style={{ borderColor: theme.colors.manatee, backgroundColor: theme.colors.snow, height: !openTask ? '85px' : 'auto', marginBlock: 10, marginBottom: 2 }}>
                            <Box display={'flex'} justifyContent={'space-between'}>
                                <Box>
                                    <Typography variant='paragraph' >
                                        {openTask === task['uuid'] ?
                                            <KeyboardArrowUp onClick={onShowInfoTask.bind(this, task['uuid'])} sx={{ float: 'left', cursor: 'pointer', mr: 2}} />
                                            :							
                                            <KeyboardArrowDown onClick={onShowInfoTask.bind(this, task['uuid'])} sx={{ float: 'left', cursor: 'pointer', mr: 2}} />
                                        }
                                    </Typography>
                                    <Typography variant='smallTitle' style={{marginRight: 5}} >{t[task['type']]}</Typography>
                                    <Typography variant='paragraph' >{t.text} {task['created_by']['name']}</Typography>
                                    {/* <Typography variant='paragraph' >{t.text} {task['type'] === 'task' ? task['assigned_to'] : task['created_by']['name'] }</Typography> */}
                                </Box>
                                <Typography variant='paragraph' >
                                    {task['edate'] && !task["is_completed"] ? 'Vence el ' : 'Finalizada el '} {moment(new Date(task['edate'])).format('LLL')}
                                </Typography>
                                {tabActive !== "history" && <Box color={"#3743aa"}>
                                    <Edit sx={{mr: 1}} onClick={onOpenDialogAction.bind(this, task)} cursor={'pointer'}/>
                                    <Delete onClick={onDelete.bind(this, task['uuid'], "delete")} cursor={'pointer'}/>
                                </Box>}
                            </Box>
                            {openTask !== task['uuid'] && 
                                <Typography variant='paragraph' style={{marginLeft: 40, display: 'flex'}}>
                                    {task['type'] === 'task' && !task['is_completed'] ? 
                                        <Tooltip title={'Pendiente: Cerrar tarea'}>
                                            <IconButton sx={{px: '0 !important', mr: 1}} onClick={onUpdateTask.bind(this, task['uuid'], 'completed')} ><CheckCircleOutline fontSize='small' color='warning' cursor={'pointer'}/></IconButton>
                                        </Tooltip> :
                                        task['type'] === 'task' && task['is_completed'] ? 
                                        <Tooltip title={'Completada'}>
                                            <IconButton sx={{px: '0 !important', mr: 1}} ><CheckCircleOutline fontSize='small' color='success'/></IconButton>
                                        </Tooltip> :
                                        null
                                    } 
                                    {getCount(task['description']) < 0 ? <MUIRichTextEditor defaultValue={task['description']} readOnly toolbar={false} /> : <Typography variant='paragraph' style={{alignSelf: 'center'}}>{getText(task['description']).substring(0,60) + '...'}</Typography>}
                                </Typography>
                            }
                            {openTask === task['uuid'] &&
                                <Box px={5} py={3}>
                                    <ThemeProvider theme={editorTheme}>
                                        <MUIRichTextEditor defaultValue={task['description']} readOnly toolbar={false}  />
                                    </ThemeProvider>
                                    
                                    <Divider sx={{my: 2}} />
                                    {!showEditor && <TextField label='Añadir un comentario...' size='small' color='secondary' sx={{mb: 2, backgroundColor: '#FFF'}} fullWidth InputLabelProps={{ shrink: true }} onClick={onOpenTextEditor.bind(this, task)} />}
                                    {showEditor && <TextEditor onConfirm={addComment} onCancel={onCloseTextEditor}/>}
                                    {task['comments'] && task['comments'].length > 0 && 
                                        <Card key={`${i}-${task['uuid']}`} fullWidth padding={2} flexDirection='column' alignItems='stretch' justifyContent='space-between' style={{  height: 'auto', width: 'auto' }}>
                                            {task['comments'].map((c, i) => {
                                                return <Box key={i}>
                                                    <Box display={'flex'} justifyContent={'space-between'}>
                                                        <Typography variant='small' >{c['agent']['name']}</Typography>
                                                        <Typography variant='small' >{moment(new Date(c['cdate'])).tz('America/Mexico_City').format('LLL')}</Typography>
                                                    </Box>
                                                    <ThemeProvider theme={editorTheme}>
                                                        <MUIRichTextEditor defaultValue={c['text']} readOnly toolbar={false} />
                                                    </ThemeProvider>
                                                    {task['comments'].length > 1 && i < task['comments'].length-1 && <Divider sx={{my: 2}} />}
                                                </Box>
                                                
                                            })} 
                                        </Card>
                                    }
                                </Box>
                            }

                        </Card>
                    })}
                    {filterTasks?.length > 0 && 
                        <CustomPagination 
                            rows={pagination.totalDocuments}
                            page={pagination.page - 1}
                            rowsPerPage={pagination.rowsPerPage}
                            handleChangePage={changePage}
                            handleChangeRowsPerPage={handleChangeRowsPerPage}
                            label={pplTab === "task" ? true : false}
                        />
                    }
                    {(!filterTasks || filterTasks?.length === 0) && 
                        <FlexGrid item style={{display: "grid", paddingBottom: '0.8rem', marginTop: 30, alignSelf: 'center'}}>
                            <Box component="img" my={2} alignSelf={"center"} alt="emptyList" src={getMessage()[0]["image"]} width={180}/>
                            <Typography variant='paragraph' style={{textAlign: "center"}} >
                                {getMessage()[0]["message"]}
                            </Typography>
                        </FlexGrid>
                    }
                    </>
                }
            </Card>
            <ManageTask
                item={itemDialog}
                open={dialogProps.open}
                onClose={onCloseDialogAction}
                onConfirm={onConfirmAction}
            />
            <ManageEvent
                item={itemDialog}
                open={dialogEvent.open}
                onClose={onCloseDialogAction}
                onConfirm={onConfirmAction}
            />
            <DeleteEvent
                open={dialogEventDelete.open}
                text={{
                    title: "¿Deseas eliminar esta tarea?",
                    message: "Si eliminas la tarea, ya no se visualizará en la sección de tareas de seguimiento y tendrás que volver a crearla si lo necesitas."
                }}
                onClose={onCloseDialogAction} 
                onConfirm={onConfirmDelete.bind(this)} 
                element={element}
            />
        </FlexGrid>
    )
}

